import FieldConfig from "../../../proto/field-config"
import FieldItemModelCalculatedLaborCost_TableCell from "./render/table/table-cell"
import FieldCurrency from "../../../generic/finance/currency/currency"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type";

export default class FieldItemModelCalculatedLaborCost extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Labor cost"
        this.label                                  = "Labor cost"

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelCalculatedLaborCost_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelCalculatedLaborCost_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    let res = 0

                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    if (listItem.view.isCollapsed &&
                        !!calculatedValues?.total?.value &&
                        calculatedValues?.total.value > calculatedValues?.own) {
                        res = calculatedValues?.total.value || 0
                    } else {
                        res = calculatedValues?.own || 0
                    }

                    return res
                }
            ],
            directions  : [sort]
        }
    }
}
